import {RewardType} from "@/Core/Reward/RewardInfo";
import UserGlobalMgr from "@/Core/UserGlobalMgr";

export class SRewardPresenter {
    static Instance: SRewardPresenter = new SRewardPresenter();

    static get gcCount(): number {
        return UserGlobalMgr.gcCount;
    } // 示例值

    static get scCountAtom(): number {
        return UserGlobalMgr.scCountAmount;
    }

    //todo 可兑换上限  需要后端返回值
    static get scAvailableToRedeem(): number {

        return 25;
    } // 示例值


}
